<template>
  <div class="row">
    <div class="col-md-4 d-flex align-items-center c-charcoal">
      {{ translationText }}
    </div>
    <div class="col-md-8 d-flex align-items-center">
      <div class="row mx-n1 w-100">
        <div
          class="col-12 col-sm px-1 my-1 my-sm-0"
          v-for="(text, index) in translationTextPluralizationArray"
          :key="`${fullTransalationKey}${index}`"
        >
          <textarea
            :ref="`${index}`"
            :placeholder="getPlaceholderText(index)"
            @input="updateTranslation"
            v-model="localTranslationTextPluralizationArray[index]"
            :name="translationKey"
            rows="1"
            class="form-control m-0 w-100"
          ></textarea>
        </div>
      </div>
      <div @click="removeSingleTranslation" class="close-icon p-1 pl-2">
        <font-awesome-icon :icon="['far', 'trash-alt']" class="fa-fw" />
      </div>
    </div>
  </div>
</template>
<script>
import { get, map } from 'lodash';
import { mapState } from 'vuex';
import { REMOVE_SINGLE_TRANSLATION } from '@/core/store/mutation-types';

export default {
  name: 'TranslationPluralizationInputGroup',
  props: {
    translationText: {
      type: String,
    },
    translationKey: {
      type: String,
    },
  },
  computed: {
    ...mapState('studio', ['currentTranslationsEditLang']),
    fullTransalationKey() {
      return `${this.currentTranslationsEditLang}.${this.translationKey}`;
    },
    translationTextPluralizationArray() {
      return this.translationText.split(/\s?[|]\s?/);
    },
    localTranslationTextPluralizationArray() {
      return this.localTranslatedText.split(/\s?[|]\s?/);
    },
  },
  data() {
    return {
      localTranslatedText: '',
      placeholders: [
        this.$t('LABEL_EDITOR.LABEL.ZERO'),
        this.$t('LABEL_EDITOR.LABEL.SINGULAR'),
        this.$t('LABEL_EDITOR.LABEL.PLURAL'),
      ],
    };
  },
  methods: {
    updateTranslation() {
      this.$emit('input', {
        translationText: map(
          this.$refs,
          (textInput, index) =>
            textInput[0].value || this.translationTextPluralizationArray[index]
        ).join(' | '),
        translationKey: this.translationKey,
      });
    },
    removeSingleTranslation() {
      this.$store.commit(`studio/${REMOVE_SINGLE_TRANSLATION}`, {
        translationKey: this.fullTransalationKey,
      });
      this.localTranslatedText = '';
    },
    getPlaceholderText(index) {
      if (this.translationTextPluralizationArray.length === 2) {
        index++;
      }
      return this.placeholders[index];
    },
    updateSavedTranslatedText() {
      this.localTranslatedText = get(
        this.$store.state.studio.translations?.translations,
        this.fullTransalationKey,
        ''
      );
    },
  },
  mounted() {
    this.updateSavedTranslatedText();
    this.unsubscribe = this.$store.subscribe(() => {
      this.updateSavedTranslatedText();
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
};
</script>
<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.close-icon {
  cursor: pointer;
  color: $medium-gray;
  &:hover {
    color: var(--brand-color, $coral);
  }
}
</style>
